// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2FeZI","question":"Question_question__R8qqh","description":"Question_description__37eMF"};